import axios from 'axios';
import store from '../store/index.js';
import Swal from 'sweetalert2'

const API = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL_IUGB,
});

API.interceptors.request.use((config)=>{
    config.headers.Authorization = `Bearer ${store.getters.token}`;
    config.headers.Accept = 'application/json';
    config.headers["Access-Control-Allow-Origin"] = "*";
    return config;
})

API.interceptors.response.use((response)=> response, (error)=>{
    if(error.response){
        switch (error.status) {
            case 400:
                error.message = "La requête envoyée par votre navigateur est incorrecte ou mal formée. Cela peut se produire si les informations que vous avez saisies ne sont pas valides."
                break;
            case 401:
                error.message = "Vous devez vous authentifier pour accéder à cette page. Votre nom d'utilisateur et votre mot de passe sont requis."
                break;
            case 403:
                error.message = "Vous n'avez pas l'autorisation d'accéder à cette ressource."
                break;
            case 404:
                error.message = "La page que vous recherchez est introuvable. Elle a peut-être été déplacée, renommée ou n'existe plus."
                break;
            case 500:
                error.message = "Une erreur inattendue s'est produite sur le serveur. Nous travaillons à la résoudre."
                break;
            default:
                error.message = "Le service est temporairement indisponible. Le serveur est peut-être en cours de maintenance ou surchargé"
                break;
        }
    }else{
        Swal.fire('Oops.. La connexion au serveur a échoué',"Cela peut être dû à un problème avec votre connexion Internet ou le serveur est temporairement indisponible",'error')
    }
    return Promise.reject(error);
})

export default API;